// ----------------------------------------------------------------------

import { useContext } from "react";

import Context from "../context";
import MessageAlert from "./MessageAlert";

export const MessageEntityAlert = () => {
	const { entity } = useContext(Context);

	const maintenanceMessage = "Esta entidad está en mantenimiento. Disculpen las molestias.";

	if (entity?.maintenance) return <MessageAlert message={maintenanceMessage} severity='warning' />;

	return null;
};

export default MessageEntityAlert;
